import gsap from "gsap";
import ServicesStyles from "@/components/Services/OurServices/OurServices.module.scss";
import { AnimationStateKeys } from "@/provider/DuckContext";
import { clone } from "three/examples/jsm/utils/SkeletonUtils";
import { Group } from "three";

interface HatModelItem {
  scene: Group;
  callback: (model: Group) => void;
}

//Hats logic functions
export function InitHatModels(models: HatModelItem[]) {
  models.forEach(({ scene, callback }) => {
    const modelClone = scene.clone();
    callback(modelClone);
  });
}

export function IntegrateHatModels(
  duckHead: any,
  duckRef: any,
  models: Array<any>
) {
  duckHead.updateMatrixWorld(true);

  models.forEach((model) => {
    duckHead.attach(model.scene);

    model.ref.current = model.scene;

    model.scene.position.copy(duckHead.position);
    model.scene.rotation.copy(duckHead.rotation);
    model.scene.scale.copy(duckRef.current.scale);

    model.scene.scale.x += model.scale;
    model.scene.scale.y += model.scale;
    model.scene.scale.z += model.scale;

    model.scene.position.y += model.position.y;
    model.scene.position.z += model.position.z;

    model.scene.rotation.y += model.rotation.y;
    model.scene.rotation.x += model.rotation.x;
  });
}

//Hats animation functions
export function simpleHatTween(target, positionY, duration) {
  gsap.to(target, {
    y: positionY,
    duration: duration,
  });
}

export function createHatTransition(
  triggerIndex,
  scene,
  firstHat,
  secondHat,
  duckHandler
) {
  return gsap.timeline({
    scrollTrigger: {
      trigger: `.${ServicesStyles.ourListDuck} > ul > li:nth-child(${triggerIndex})`,
      start: "top-=200 center",
      onEnter: () => {
        transitionHatTween(
          { target: scene.target, rotation: scene.rotation },
          { target: firstHat.target, positionY: firstHat.yOut, duration: 0.8 },
          { target: secondHat.target, positionY: secondHat.yIn, duration: 0.5 },
          duckHandler
        );
      },
      onLeaveBack: () => {
        transitionHatTween(
          { target: scene.target, rotation: scene.rotation - Math.PI * 2 },
          {
            target: secondHat.target,
            positionY: secondHat.yOut,
            duration: 0.8,
          },
          { target: firstHat.target, positionY: firstHat.yIn, duration: 0.5 },
          duckHandler
        );
      },
    },
  });
}

function transitionHatTween(scene, firstHat, secondHat, duckHandler) {
  gsap
    .timeline({
      onStart: () => {
        duckHandler(AnimationStateKeys.JUMP);
        gsap.to(scene.target, {
          y: scene.rotation,
          duration: 1,
        });
      },
    })
    .to(firstHat.target, {
      y: firstHat.positionY,
      duration: firstHat.duration,
    })
    .to(
      secondHat.target,
      {
        y: secondHat.positionY,
        duration: secondHat.duration,
      },
      "<+=75%"
    );
}
